/*
import './dropdown.plugin';
import './stickyElement.plugin';
*/
import './accordion.plugin';
import './tabs.plugin';
import './stickyHeader.plugin';

import './lib/slick';

$(function() {
    $('header.primary').stickyHeader();
    $('.accordion-block').accordion();

    var $smsChildren = $('.show-me-success .slides').children().length;

    $('.show-me-success').addClass('has-' + $smsChildren + '-children');

    if($smsChildren > 2) {
        $('.show-me-success .slides').slick({
            dots: false,
            arrows: true,
            variableWidth: true,
            nextArrow: '.show-me-success .advance'
        });
    }
});

var $window = $(window);
var $html = $('html');
var $body = $('body');


/* Sticky Nav Styling Hooks */

$window.scroll(function() {
    if($window.scrollTop() > 20){
        $body.addClass('scrolled');
    }else{
        $body.removeClass('scrolled');
    }
});
$window.scroll();


/* Animated Anchor Scroll */

$('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - $('header.primary').height()
            }, 1000);
        return false;
        }
    }
});


/* Open internal links in current tab, external in new tab */

$('a[href]').click(function() {
    var a = new RegExp('/' + window.location.host + '/');
    var r = new RegExp('^(?:[a-z]+:)?//', 'i'); //relative path
    if (!a.test(this.host) && !r.test(this.href)) {
        console.log('was external');
        window.open(this.href);
        return false;
    }
});


/* Mobile Navigation */

$('.menu-toggle').click(function() {
    $body.toggleClass('menu-hidden').toggleClass('menu-showing');
});

$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
        if($body.hasClass('menu-showing')){
            $body.removeClass('menu-showing').addClass('menu-hidden');
        }
    }
});

/* Search Bar */

$('.search_link').click(function(e) {
    e.preventDefault();
    $('.nav-search').toggleClass('close');
})


// WEBPACK FOOTER //
// ./src/js/site.js